import SvgCoupon from '~/components/ui/icon/icons/Coupon';
import SvgDeviceMobile from '~/components/ui/icon/icons/DeviceMobile';
import SvgLink from '~/components/ui/icon/icons/Link';
import SvgPdf from '~/components/ui/icon/icons/Pdf';
import SvgPhoto from '~/components/ui/icon/icons/Photo';
import SvgSocialMedia from '~/components/ui/icon/icons/SocialMedia';
import SvgUserId from '~/components/ui/icon/icons/UserId';
import SvgVideo from '~/components/ui/icon/icons/Video';
import SvgWorld from '~/components/ui/icon/icons/World';
import { QRCODE_DYNAMIC_MICROSITE_TYPE } from '~/constants/qr-code';

export const dynamicQRsIcons = [
  { id: QRCODE_DYNAMIC_MICROSITE_TYPE.WEBSITE, Icon: SvgWorld },
  { id: QRCODE_DYNAMIC_MICROSITE_TYPE.PDF, Icon: SvgPdf },
  { id: QRCODE_DYNAMIC_MICROSITE_TYPE.LINKS, Icon: SvgLink },
  { id: QRCODE_DYNAMIC_MICROSITE_TYPE.APP, Icon: SvgDeviceMobile },
  { id: QRCODE_DYNAMIC_MICROSITE_TYPE.IMAGES, Icon: SvgPhoto },
  { id: QRCODE_DYNAMIC_MICROSITE_TYPE.VCARD_PLUS, Icon: SvgUserId },
  { id: QRCODE_DYNAMIC_MICROSITE_TYPE.SOCIAL_MEDIA, Icon: SvgSocialMedia },
  { id: QRCODE_DYNAMIC_MICROSITE_TYPE.COUPON, Icon: SvgCoupon },
  { id: QRCODE_DYNAMIC_MICROSITE_TYPE.VIDEO, Icon: SvgVideo },
];
